<app-loading *ngIf="cargando || carEstados"></app-loading>
<div *ngIf="!cargando">
  <div [hidden]="carEstados">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTAREINTENTO.LBL_CONTROL' | translate }}</label>
            <p-dropdown disableTab  id="idControl{{fluVentaPaso.codigo}}" name="nomControl{{fluVentaPaso.codigo}}"
                        [options]="lisControles" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idControl"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idControl.invalid">
              {{ 'FLUJOVENTAREINTENTO.LBL_CONTROL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12" [className]="f.indicadorAplicaReintentos.value ? 'md:col-3 lg:col-3' : 'md:col-6 lg:col-6'">
          <p-checkbox label="{{ 'FLUJOVENTAREINTENTO.LBL_REQUIEREREINTENTO' | translate}}" binary="true"
                      id="indicadorReintento{{fluVentaPaso.codigo}}" (onChange)="cambioIntento($event.checked)"
                      name="nomIndicadorReintento{{fluVentaPaso.codigo}}"
                      formControlName="indicadorAplicaReintentos"></p-checkbox>
        </div>
        <div class="col-12 md:col-3 lg:col-3" *ngIf="f.indicadorAplicaReintentos.value">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTAREINTENTO.LBL_CANTIDADREINTENTOS' | translate }}</label>
            <input type="text" pInputText id="idCantidad{{fluVentaPaso.codigo}}" name="nomCantidad{{fluVentaPaso.codigo}}"
                   autocomplete="off" [minimo]="1"
                   formControlName="cantidadReintentos"
                   [maxlength]="3"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.cantidadReintentos.invalid">
              {{ 'FLUJOVENTAREINTENTO.LBL_CANTIDADREINTENTOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTAREINTENTO.LBL_ESTADO' | translate }}</label>
            <p-dropdown disableTab  id="idEstado{{fluVentaPaso.codigo}}" name="nomEstado{{fluVentaPaso.codigo}}"
                        [options]="lisEstados" filter="filter" (onChange)="cargarCausales($event.value)"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idEstado"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
              {{ 'FLUJOVENTAREINTENTO.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'FLUJOVENTAREINTENTO.LBL_CAUSAL' | translate }}</label>
            <p-multiSelect id="idCausal" name="nomCausal" [options]="lisCausales"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}" *ngIf="!carEstados"
                           selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                           formControlName="idCausales"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausales.invalid">
              {{ 'FLUJOVENTAREINTENTO.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'FLUJOVENTAREINTENTO.LBL_REQUIERERECOMENTARIO' | translate}}" binary="true"
                      id="indicadorComentario{{fluVentaPaso.codigo}}"
                      name="nomIndicadorComentario{{fluVentaPaso.codigo}}"
                      formControlName="indicadorMostrarObservacion"></p-checkbox>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                      id="indicador{{fluVentaPaso.codigo}}"
                      name="nomIndicador{{fluVentaPaso.codigo}}"
                      formControlName="indicadorHabilitado"></p-checkbox>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{(regSeleccionado ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                  type="button" (click)="onSubmit()"
                  pButton></button>
        </div>
      </div>
    </form>


    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" #dt
                 [value]="listado"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.control}}</td>
              <td>{{row.cantidadReintentos}}</td>
              <td>{{row.estado}}</td>
              <td>{{row.causal}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorMostrarObservacion" binary="true"
                            disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true"
                            disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons" *ngIf="verRegresar">
      <div class="form-group col-12">
        <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                pButton (click)="salir()"></button>
      </div>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="flujoVentaReintento{{fluVentaPaso.codigo}}">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
